import { render, staticRenderFns } from "./CanvasPanel.vue?vue&type=template&id=a665547c&scoped=true"
import script from "./CanvasPanel.vue?vue&type=script&lang=js"
export * from "./CanvasPanel.vue?vue&type=script&lang=js"
import style0 from "./CanvasPanel.vue?vue&type=style&index=0&id=a665547c&prod&lang=css"
import style1 from "./CanvasPanel.vue?vue&type=style&index=1&id=a665547c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665547c",
  null
  
)

export default component.exports